export var formatPercentage = {
    id: "formatPercentage",
    definition: function (value) {
        return value ? value.toFixed(2) : value;
    }
};
